module.exports = __webpack_public_path__ + "media/images/mastercard-partner-0634f721.svg";